 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import BACKEDTLU_1 from '@/components/Backed/tlu_1'
 import BACKEDMM from '@/components/Backed/mm'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import DED from '@/components/ded'
 import CONTENT from '@/components/content'
 import PROLOGUE from '@/components/Prologue'
 import PART_ONE from '@/components/Part_One'
 import CHAP1 from '@/components/chap1'
 import CHAP2 from '@/components/chap2'
 import CHAP3 from '@/components/chap3'
 import CHAP4 from '@/components/chap4'
 import CHAP5 from '@/components/chap5'
 import CHAP6 from '@/components/chap6'
 import PART_TWO from '@/components/Part_Two'
 import CHAP7 from '@/components/chap7'
 import CHAP8 from '@/components/chap8'
 import CHAP9 from '@/components/chap9'
 import CHAP10 from '@/components/chap10'
 import CHAP11 from '@/components/chap11'
 import CHAP12 from '@/components/chap12'
 import CHAP13 from '@/components/chap13'
 import PART_THREE from '@/components/Part_Three'
 import CHAP14 from '@/components/chap14'
 import CHAP15 from '@/components/chap15'
 import CHAP16 from '@/components/chap16'
 import CHAP17 from '@/components/chap17'
 import CHAP18 from '@/components/chap18'
 import PART_FOUR from '@/components/Part_Four'
 import CHAP19 from '@/components/chap19'
 import CHAP20 from '@/components/chap20'
 import CHAP21 from '@/components/chap21'
 import CHAP22 from '@/components/chap22'
 import CHAP23 from '@/components/chap23'
 import CHAP24 from '@/components/chap24'
 import CHAP25 from '@/components/chap25'
 import CHAP26 from '@/components/chap26'
 import PART_FIVE from '@/components/Part_Five'
 import CHAP27 from '@/components/chap27'
 import CHAP28 from '@/components/chap28'
 import CHAP29 from '@/components/chap29'
 import CHAP30 from '@/components/chap30'
 import CHAP31 from '@/components/chap31'
 import CHAP32 from '@/components/chap32'
 import CHAP33 from '@/components/chap33'
 import CHAP34 from '@/components/chap34'
 import LOVE_2 from '@/components/love_2'
 import EPILOGUE from '@/components/Epilogue'
 import BIO from '@/components/bio'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import CH050 from '@/components/ch050'
 import CH050A from '@/components/ch050a'
 import CH050B from '@/components/ch050b'
 import CH050C from '@/components/ch050c'
 import CRT from '@/components/crt'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIMad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/content",
 			"name" : "content",
 			"component" : CONTENT
 		},
 		{
 			"path" : "/Prologue",
 			"name" : "Prologue",
 			"component" : PROLOGUE
 		},
 		{
 			"path" : "/Part_One",
 			"name" : "Part_One",
 			"component" : PART_ONE
 		},
 		{
 			"path" : "/chap1",
 			"name" : "chap1",
 			"component" : CHAP1
 		},
 		{
 			"path" : "/chap2",
 			"name" : "chap2",
 			"component" : CHAP2
 		},
 		{
 			"path" : "/chap3",
 			"name" : "chap3",
 			"component" : CHAP3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js